// extracted by mini-css-extract-plugin
export default {"page":"OY-z","cartModal":"PY-z","checkout":"QY-z","placeholder":"RY-z","account":"SY-z"};